import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { AuthenticationComponent } from './auth/authentication/authentication.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { ProofOfLifeComponent } from './features/proof-of-life/proof-of-life.component';
import { DiretosCorrecaoComponent } from './pages/diretos-correcao/diretos-correcao.component';
import { DirecionamentoDeOfertasComponent } from './pages/gestao-do-consentimento/direcionamento-de-ofertas/direcionamento-de-ofertas.component';
import { GerenciarPreferenciasComponent } from './pages/gestao-do-consentimento/gerenciar-preferencias/gerenciar-preferencias.component';
import { HistoricoSolicitacoesComponent } from './pages/historico-solicitacoes/historico-solicitacoes.component';
import { ComoProtegemosSeusDadosComponent } from './pages/landing/como-protegemos-seus-dados/como-protegemos-seus-dados.component';
import { ConhecaNossoTrabalhoComponent } from './pages/landing/conheca-nosso-trabalho/conheca-nosso-trabalho.component';
import { ConhecaSeusDireitosComponent } from './pages/landing/conheca-seus-direitos/conheca-seus-direitos.component';
import { FinalidadesDeUsoComponent } from './pages/landing/finalidades-de-uso/finalidades-de-uso.component';
import { RelatorioAnaliticoComponent } from './pages/relatorio-analitico/relatorio-analitico.component';
import { RelatorioSinteticoComponent } from './pages/relatorio-sintetico/relatorio-sintetico.component';

const routerOptions: ExtraOptions = {
  anchorScrolling: 'enabled',
  onSameUrlNavigation: 'reload'
};

const routes: Routes = [
  {path: '', redirectTo:'como-tratamos-seus-dados', pathMatch: 'full'},
  {path: 'relatorio-sintetico', component: RelatorioSinteticoComponent},
  {path: 'relatorio-analitico', component: RelatorioAnaliticoComponent},
  {path: 'conheca-seus-direitos', component: ConhecaSeusDireitosComponent},
  {path: 'como-tratamos-seus-dados', component: ConhecaNossoTrabalhoComponent},
  {path: 'entenda-as-finalidades-de-uso', component: FinalidadesDeUsoComponent},
  {path: 'como-protegemos-seus-dados', component: ComoProtegemosSeusDadosComponent},
  {path: 'prova-de-vida', component: ProofOfLifeComponent},
  {path: 'gerenciar-preferencias', component: GerenciarPreferenciasComponent},
  {path: 'autenticacao', component: AuthenticationComponent},
  {path: 'direcionamento-de-ofertas', component: DirecionamentoDeOfertasComponent},
  {path: 'direitos-de-correcao', component: DiretosCorrecaoComponent},
  {path: 'historico-solicitacoes', component: HistoricoSolicitacoesComponent},
  {path: 'erro', component: ErrorPageComponent}

];

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
